import { render } from "./TheAboutMeComponent.vue?vue&type=template&id=d74bab60&scoped=true"
import script from "./TheAboutMeComponent.vue?vue&type=script&lang=js"
export * from "./TheAboutMeComponent.vue?vue&type=script&lang=js"

import "./TheAboutMeComponent.vue?vue&type=style&index=0&id=d74bab60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74bab60"]])

export default __exports__